import React from "react";
import "./Team.css";
import { NavLink } from "react-router-dom";
import TeamCard from '../components/TeamCard'


const Team = () => {
  return (
    <>
      <div classNameName="maincontent">
      <div className="typewriter-text2 text-center p-md-0"><h1 className="">CORE TEAM 2023-24</h1></div>
        

        <div className="mt-5 mb-5">
          <ul class="nav nav-underline justify-content-center">
            <li class="nav-item">
            <NavLink class="nav-link" to="/team" style={{ textDecoration: 'none',color:'black'}}>
            <button className='btn btn-primary px-4'>Core Team</button>
              </NavLink>
            </li>
            <li class="nav-item">
              <NavLink class="nav-link" to="/developer" style={{ textDecoration: 'none' }}>
              <button className='btn btn-light text-dark px-2'>Developers</button>
              </NavLink>
            </li>
          </ul>
        </div>

        <p
          style={{ textAlign: "center", fontSize: "1.5rem", fontWeight: "600" }}
        >
          {" "}
          Our Inspiration
        </p>

        
        <hr width="100%" />

        <div className="container mb-0">
          <div className="card_team-wrapper" style={{padding:"12px"}}>
            {/* <!-- Profile 1 --> */}
            <div className="card_team shadow">
              <div className="profile-img" style={{padding:"6px"}}>
                <img src="https://www.pict.edu/Director-message/Director.png" className="rounded-circle" alt='myimg' />
              </div>
              <div className="content">
                <h3 style={{padding:"1px"}}>Dr. Prahlad T. Kulkarni</h3>
                <hr />
                <div className="social-media">
                <p>Director</p>
                
                {/* <a href={`mailto:asingole@pict.edu`} target='_blank'><i
                    className="fa fa-envelope"
                    style={{ color: "red", fontSize: "32px" }}
                  ></i></a>
                  <a href="https://www.linkedin.com" target='_blank'><i
                    className="fa fa-linkedin-square"
                    style={{ fontSize: "32px", color: "blue" }}
                  ></i></a> */}
                  
                </div>
              </div>
            </div>
            <div className="card_team shadow">
              <div className="profile-img" style={{padding:"6px"}}>
                <img src="https://pict.edu/principal-message/pdf/stgandhe.jpg" className="rounded-circle" alt='myimg' />
              </div>
              <div className="content">
                <h3 style={{padding:"1px"}}>Dr. Sanjay Gandhe</h3>
 <hr />                
 <div className="social-media">
                <p>Principal</p>
               
                {/* <a href={`mailto:asingole@pict.edu`} target='_blank'><i
                    className="fa fa-envelope"
                    style={{ color: "red", fontSize: "32px" }}
                  ></i></a>
                  <a href="https://www.linkedin.com" target='_blank'><i
                    className="fa fa-linkedin-square"
                    style={{ fontSize: "32px", color: "blue" }}
                  ></i></a> */}
                  
                </div>
              </div>
            </div>
            {/* <TeamCard name="Amol Ingole" position="Faculty Head" imageLink="https://i.pinimg.com/736x/6e/b9/48/6eb948f71dbe63f16dd15cc7c912b683.jpg" gmail="https://www.gmail.com" linkedin="https://www.linkedin.com" github="https://www.github.com"/> */}

         
            {/* <TeamCard name="Amol Ingole" position="Faculty Head" imageLink="https://i.pinimg.com/736x/6e/b9/48/6eb948f71dbe63f16dd15cc7c912b683.jpg" gmail="https://www.gmail.com" linkedin="https://www.linkedin.com" github="https://www.github.com"/> */}

          </div>
        </div>


        <p
          style={{ textAlign: "center", fontSize: "1.5rem", fontWeight: "600" }}
        >
          {" "}
          Faculty Coordinators
        </p>

        
        <hr width="100%" />
        

        <div className="container">
          <div className="card_team-wrapper" style={{padding:"12px"}}>
            {/* <!-- Profile 1 --> */}
            <div className="card_team shadow">
              <div className="profile-img" style={{padding:"6px"}}>
                <img src="https://i.postimg.cc/7hpSZ70h/Whats-App-Image-2024-04-17-at-20-13-52-3e560c52.jpg" className="rounded-circle" alt='myimg' />
              </div>
              <div className="content">
                <h3 style={{padding:"1px"}}>Amol Ingole</h3>
                <p>Faculty Coordinator</p>
                <hr />
                <div className="social-media">
                <a href={`mailto:asingole@pict.edu`} target='_blank'><i
                    className="fa fa-envelope"
                    style={{ color: "red", fontSize: "32px" }}
                  ></i></a>
                  <a href="https://www.linkedin.com" target='_blank'><i
                    className="fa fa-linkedin-square"
                    style={{ fontSize: "32px", color: "blue" }}
                  ></i></a>
                  
                </div>
              </div>
            </div>
            {/* <TeamCard name="Amol Ingole" position="Faculty Head" imageLink="https://i.pinimg.com/736x/6e/b9/48/6eb948f71dbe63f16dd15cc7c912b683.jpg" gmail="https://www.gmail.com" linkedin="https://www.linkedin.com" github="https://www.github.com"/> */}

            {/* <!-- Profile 2 --> */}
            <div className="card_team shadow">
              <div className="profile-img" style={{padding:"6px"}}>
                <img src="https://i.postimg.cc/Y0cg2d2L/Whats-App-Image-2024-04-17-at-12-48-49-7b4a446c.jpg" className="rounded-circle" alt='myimg' />
              </div>
              <div className="content">
                <h3 style={{padding:"1px"}}>Sunil Khot</h3>
                <p>Faculty Coordinator</p>
                <hr />
                <div className="social-media">
                <a href={`mailto:sskhot@pict.edu`} target='_blank'><i
                    className="fa fa-envelope"
                    style={{ color: "red", fontSize: "32px" }}
                  ></i></a>
                  <a href="https://www.linkedin.com" target='_blank'><i
                    className="fa fa-linkedin-square"
                    style={{ fontSize: "32px", color: "blue" }}
                  ></i></a>
                
                </div>
              </div>
            </div>
            {/* <TeamCard name="Amol Ingole" position="Faculty Head" imageLink="https://i.pinimg.com/736x/6e/b9/48/6eb948f71dbe63f16dd15cc7c912b683.jpg" gmail="https://www.gmail.com" linkedin="https://www.linkedin.com" github="https://www.github.com"/> */}

          </div>
        </div>

        <p style={{ textAlign: "center", fontSize: "1.5rem", fontWeight: "600" }}>
          {" "} Core Team </p>
        <hr width="100%" className="mb-5"/>

        <div className="card_team-wrapper2">
          
          <TeamCard name="Vishal Bhokre" position="Activity Head" imageLink="https://i.postimg.cc/nrhVMWVW/Whats-App-Image-2024-07-17-at-23-40-07-3a6ea6bf.jpg" gmail="vishalbhokre99@gmail.com" linkedin="https://www.linkedin.com/in/vishal-bhokre-9604211b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://github.com/itsvishal07"/>

          <TeamCard name="Pranav Dangare" position="Activity Head" imageLink="https://i.postimg.cc/904G214s/IMG-20240210-112438170-HDR-AE-2.jpg" gmail="pranavdangare13@gmail.com" linkedin="https://www.linkedin.com/in/pranav-dangare-a040b3230/" github="https://www.github.com"/>

          <TeamCard name="Vinayak Vairat" position="Activity Head" imageLink="https://i.postimg.cc/Ghs73Jsx/Vinayak-Vairat.jpg" gmail="vairatvinayak@gmail.com" linkedin="https://www.linkedin.com/in/vinayak-vairat-ab3759229?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com"/>

          <TeamCard name="Pranav Nimbalkar" position="Treasurer" imageLink="https://i.postimg.cc/4y2DCJq4/Pranav-Kiran-Nimbalkar.jpg" gmail="Pranavn5402@gmail.com" linkedin="https://www.linkedin.com/in/pranav-nimbalkar-a27339290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://github.com/Pranavn510"/>

        </div>
        <div className="card_team-wrapper2">
          <TeamCard name="Rohit Pimple" position="Technical Head" imageLink="https://i.postimg.cc/SxLTztn4/IMG-20240417-200218.jpg" gmail="rohitpimple623@gmail.com" linkedin="https://www.linkedin.com/in/rohitpimple/" github="https://github.com/rohitpimple"/>

          <TeamCard name="Darshan Mahajan" position="App Head" imageLink="https://i.postimg.cc/dVZYYyJb/Darshan-Mahajan.jpg" gmail="darshanmahajan101@gmail.com" linkedin="https://www.linkedin.com/in/darshan-mahajan-74179a23b/" github="https://github.com/radar101"/>

          <TeamCard name="Pranav Bhiungade" position="Frontend Head" imageLink="https://i.postimg.cc/BbNcW4Kw/pranav-Crop.jpg" gmail="pranavbhiungade25@gmail.com" linkedin="https://www.linkedin.com/in/pranav-bhiungade-4369741b1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://github.com/pranavzz"/>

          <TeamCard name="Adarsh Jain" position="Backend Head" imageLink="https://i.postimg.cc/QMqnG8WL/Adarsh-Jain.jpg" gmail="adarshjain0508@gmail.com" linkedin="https://www.linkedin.com/in/adarsh-jain-37aaa622a" github="https://www.github.com/ajain0508"/>

        </div>
        <div className="card_team-wrapper2">

          <TeamCard name="Ajit Kale" position="Design Head" imageLink="https://i.postimg.cc/dVhhDD4c/ajit7.jpg" gmail="ajitkale2406@gmail.com" linkedin="https://www.linkedin.com/in/ajit-kale-4a759625a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com"/>

          <TeamCard name="Parth Sali" position="Design Head" imageLink="https://i.postimg.cc/pTRbzcKv/Parth-Sali.jpg" gmail="parthsali04@gmail.com" linkedin="https://www.linkedin.com/in/parthsali/" github="https://github.com/parthsali"/>

          <TeamCard name="Mangesh Salunke" position="Content Head" imageLink="https://i.postimg.cc/TP9jJKMN/Whats-App-Image-2024-04-17-at-20-13-39-607e08fa.jpg" gmail="mangesh13salunke@gmail.com" linkedin="https://www.linkedin.com/in/mangeshsalunke?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com"/>

          <TeamCard name="Rushikesh Edne" position="Content Head" imageLink="https://i.postimg.cc/xjZpSFqd/Rushikesh-Edne.jpg" gmail="rushikeshedne30@gmail.com" linkedin="https://www.linkedin.com/in/rushikesh-edne-b63344290/" github="https://github.com/RushikeshEdne"/>
 
        </div>
        <div className="card_team-wrapper2">
          <TeamCard name="Anushka Doiphode" position="Data and Documentation Head" imageLink="https://i.postimg.cc/k4srcNyb/Anushka-Doiphode.jpg" gmail="anushkadoiphode07@gmail.com " linkedin="https://www.linkedin.com/in/anushka-doiphode/" github="https://github.com/anushkadoiphode07"/>

          <TeamCard name="Sanjana Mandlecha" position="Data and Documentation Head" imageLink="https://i.postimg.cc/Y9nn0d3b/Sanjana-Mandlecha.jpg" gmail="sanjana.mandlecha6@gmail.com" linkedin="https://www.linkedin.com/in/sanjana-mandlecha-553a96229?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://github.com/SanjanaMandlecha"/>

          <TeamCard name="Suraj Mohite" position="Publicity Head" imageLink="https://i.postimg.cc/8zRZMp4F/Suraj-Mohite.jpg" gmail="surajmohite928@gmail.com" linkedin="https://www.linkedin.com/in/suraj-mohite-40854322a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com/SurajMohite007"/>

          <TeamCard name="Pratiksha Garje" position="Publicity head " imageLink="https://i.postimg.cc/1zSYjnXc/Pratiksha-Garje.jpg" gmail="pratikshagarje3@gmail.com" linkedin="https://www.linkedin.com/in/pratiksha-garje-52613b219" github="https://www.github.com/pratiksha_garje07"/>
        </div>

        <div className="card_team-wrapper2">
          <TeamCard name="Chaitanya Tungar" position="Video Editing Head" imageLink="https://i.postimg.cc/x8B6yqBm/Chaitanya-Tungar.png" gmail="chaitanyatungar@gmail.com" linkedin="https://www.linkedin.com/in/chaitanyatungar" github="https://www.github.com"/>

          <TeamCard name="Ujwal Khairnar" position="Video Editing Head" imageLink="https://i.postimg.cc/667JRZvy/Ujwal-Khairnar.jpg" gmail="khairnarujwal02@gmail.com" linkedin="https://www.linkedin.com/in/ujwal-khairnar-b88aba231/" github="https://github.com/Ujwal-Khairnar"/>

          <TeamCard name="Gargi Meshram" position="Social Media Head" imageLink="https://i.postimg.cc/5twWHWYp/Gargi-Meshram.jpg" gmail="meshramgargi286@gmail.com" linkedin="https://www.linkedin.com/in/gargi-meshram-3b0932251?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com"/>

          <TeamCard name="Gauri Shelke" position="Social Media Head" imageLink="https://i.postimg.cc/43CTNxdm/Gauri-Shelke.jpg" gmail="gauri.shelke1509@gmail.com" linkedin="https://www.linkedin.com/in/gauri-shelke-57868922a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com"/>
        </div>

        <div className="card_team-wrapper2">
          <TeamCard name="Shruti Patil" position="External Affairs Head " imageLink="https://i.postimg.cc/wjpSSbbm/SHRUTI-PATIL.jpg" gmail="patilshruti312003@gmail.com" linkedin="https://www.linkedin.com/in/shruti-patil-09012a252?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" github="https://www.github.com"/>

          <TeamCard name="Manavi Khopade" position="Soft Skills Head" imageLink="https://i.postimg.cc/F1txk8Jg/Manavi-Khopade.jpg" gmail="manaviik.24@gmail.com" linkedin="https://www.linkedin.com/in/manavikhopade24" github="https://github.com/Manavik24"/>

          <TeamCard name="Janvi" position="School Teaching Head" imageLink="https://i.postimg.cc/3JdMXv0k/Janvi.jpg" gmail="janvi220803@gmail.com" linkedin="www.linkedin.com/in/janvipict2025" github="https://github.com/janvi2208"/>
        </div>
      </div>
    </>
  );
};

export default Team;
